import * as React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainPanel from "../pages/MainPanel";
import ConfigurePage from "../pages/ConfigurePage";
import AuthPopup from "../pages/AuthPopup";
import AuthCallback from "../pages/AuthCallback";
import JoinPage from "../pages/JoinPage";
import * as microsoftTeams from "@microsoft/teams-js";

export const AppRoute = () => {
  React.useEffect(() => {
    microsoftTeams.app
      .initialize()
      .then(() => {
        microsoftTeams.app.notifyAppLoaded();
        microsoftTeams.app.notifySuccess();
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <React.Fragment>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<JoinPage />} />
          <Route path="/dashboard" element={<MainPanel />} />
          <Route path="/configure" element={<ConfigurePage />} />
          <Route path="/auth-popup" element={<AuthPopup />} />
          <Route path="/authcallback" element={<AuthCallback />} />
          <Route path="*" element={<JoinPage />} />
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
};
